import { useTranslation } from "@/language"
/**
 * Navigation Tabs Component
 * Horizontal navigation with 4 tabs: Home, Explore, Connect, Chats
 * Desktop only (hidden on mobile < 768px)
 * Follows Rituality design system: 24px gap, active underline, hover states
 */

import { NavLink, useLocation } from "react-router-dom"

export function NavigationTabs() {
  const { t } = useTranslation("common")
  const location = useLocation()

  const navItems = [
    { label: t("sidebar.nav.myRituality"), path: "/my-rituality" } as const,
    { label: t("sidebar.nav.learnAndPractice"), path: "/learn-and-practice" } as const,
    { label: t("sidebar.nav.connect"), path: "/connect" } as const,
    { label: t("sidebar.nav.blog"), href: "https://myrituality.com/blog/" } as const,
  ]

  const isActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/"
    }
    return location.pathname.startsWith(path)
  }

  return (
    <nav className="hidden lg:flex items-center gap-10" aria-label={t("header.mainNav")}>
      {navItems.map(item =>
        item.href ? (
          <a
            key={item.href}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="relative transition-colors text-[14px] font-normal leading-[20px] py-2 uppercase text-white"
          >
            {item.label}
          </a>
        ) : (
          <NavLink
            key={item.path}
            to={item.path}
            className={`relative transition-colors text-[14px] font-normal leading-[20px] py-2 uppercase ${
              isActive(item.path) ? "font-semibold" : "font-normal"
            }`}
            aria-current={isActive(item.path) ? "page" : undefined}
          >
            <span className={isActive(item.path) ? "text-white" : "text-white"}>{item.label}</span>
          </NavLink>
        ),
      )}
    </nav>
  )
}
